module.exports = "/assets/data/f081d32c1a0329089f374fe869d72044-NE7.data.json";